import { Row, Button, Col, Alert } from 'antd';
import deepEqual from 'components/utils/deepEqual';
import React from 'react';
import {
  ListChoice,
  ListChoiceItem,
  RowEntryAnchorDatatype,
  RowEntryDatatype,
  TableChoiceView,
} from 'services/hitchit/types/Choices';
import { Table } from 'antd';

const ConfigureTableListField = ({
  choice,
  preference,
  savedPreference,
  onChange,
  onReset,
  onClear,
  onCancel,
  onSave,
}: {
  choice: ListChoice;
  preference?: ListChoiceItem;
  savedPreference?: ListChoiceItem;
  onChange: (choice: ListChoiceItem | undefined) => void;
  onReset: () => void;
  onClear: () => void;
  onCancel: () => void;
  onSave: () => void;
}): JSX.Element => {
  const tableChoiceView = choice.view as TableChoiceView;

  const renderColumnByDataType = (datatype: RowEntryDatatype) => {
    switch (datatype) {
      case 'anchor':
        // eslint-disable-next-line react/display-name
        return (rowEntryAnchorDataType: RowEntryAnchorDatatype) => {
          if (!rowEntryAnchorDataType) {
            return <></>;
          }
          const { href, text } = rowEntryAnchorDataType;
          return (
            <a href={href} rel="noreferrer" target="_blank">
              {text}
            </a>
          );
        };
      case 'string':
        return (text: string) => text;
      case 'date':
      default:
        throw new Error(`datatype ${datatype} not yet supported`);
    }
  };

  const columns = tableChoiceView.data.map(({ id, title, datatype }) => ({
    title,
    dataIndex: id,
    render: renderColumnByDataType(datatype),
  }));

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      if (!selectedRowKeys) {
        onChange(undefined);
      } else if (selectedRowKeys.length === 1) {
        const existingChoice = choice?.choices.find(({ id }) => id === selectedRowKeys[0]);
        onChange(existingChoice);
      } else {
        throw new Error('multipleRows is not supported');
      }
    },
    // getCheckboxProps: (record: ListChoiceItem) => ({
    //   disabled: record.name === 'Disabled User', // Column configuration not to be checked
    //   name: record.name,
    // }),
    selectedRowKeys: preference ? [preference.id] : [],
  };

  // const { tags, inputVisible, inputValue, editInputIndex, editInputValue } = this.state;
  return (
    <Row gutter={[8, 8]} style={{ textAlign: 'left' }}>
      <Col span={24}>
        {choice ? (
          <Table<Record<string, string>>
            rowSelection={{
              type: 'radio',
              ...rowSelection,
            }}
            columns={columns}
            dataSource={choice.choices.map(({ id, columns }) => ({ key: id, ...columns }))}
            pagination={false}
          />
        ) : undefined}
      </Col>
      {choice.infoText && (
        <Col>
          <Alert
            style={{ padding: 16, margin: 16 }}
            message={choice.infoText}
            type="info"
            showIcon
          />
        </Col>
      )}
      <Col>
        <Button type="primary" disabled={deepEqual(savedPreference, preference)} onClick={onSave}>
          Save changes
        </Button>
      </Col>
      <Col>
        <Button disabled={deepEqual(savedPreference, preference)} type="ghost" onClick={onCancel}>
          Cancel change
        </Button>
      </Col>
      {choice.default && (
        <Col>
          <Button type="ghost" onClick={onReset}>
            Pick default
          </Button>
        </Col>
      )}
      <Col>
        <Button type="ghost" onClick={onClear}>
          Clear
        </Button>
      </Col>
    </Row>
  );
};

export default ConfigureTableListField;
